// extracted by mini-css-extract-plugin
export var accordionWrapper = "k_S";
export var addTransition = "k_T";
export var content = "k_V";